import { render, staticRenderFns } from "./createTemplate.vue?vue&type=template&id=488bda92&scoped=true"
import script from "./createTemplate.vue?vue&type=script&lang=js"
export * from "./createTemplate.vue?vue&type=script&lang=js"
import style0 from "./createTemplate.vue?vue&type=style&index=0&id=488bda92&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488bda92",
  null
  
)

export default component.exports